export default {"src":"/_next/static/media/bladder_infections.80c8e5b4.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};